export * from "./api.data.service";
export * from "./module/api.data.module";


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/data/index.ts